import { PLANETS_CONTRACT_ADDRESS } from "@constants/env";
import { DeedType } from "@customTypes/Deed/DeedType";
import { IDeed } from "@interfaces/Deeds/Deed";

export const getDeedTypeByContract = (contractAddress: string): DeedType =>
    contractAddress === PLANETS_CONTRACT_ADDRESS.toLowerCase() ? DeedType.PLANET : DeedType.ROOM;

export const getTokensByDeedType = (mintedTokens: IDeed[], deedType: DeedType): IDeed[] =>
    mintedTokens.filter(({ type }) => deedType === type);
